<template>
  <div class="layout">
    <div class="header">
      <!-- 抽屉 -->
      <el-drawer
        v-model="mydata.drawer2"
        :direction="mydata.direction"
        style="width: 343vw"
        :z-index="9999999999"
        :append-to-body="true"
      >
        <template #default>
          <!-- <div class="menu-box">
            <el-menu
              :default-active="mydata.activeIndex"
              class="my-menu-box"
              mode="vertical"
              ellipsis:true
            >
              <el-menu-item index="1" @click="homeButton">首页</el-menu-item>
              <el-sub-menu
                index="2"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper"
              >
                <template #title>图书介绍</template>
                <el-menu-item index="2-1" @click="highSchoolButton"
                  >高中书系</el-menu-item
                >
                <el-menu-item index="2-2" @click="middleSchoolButton"
                  >初中书系</el-menu-item
                >
                <el-menu-item index="2-3" @click="primarySchoolButton"
                  >小学书系</el-menu-item
                >
              </el-sub-menu>
              <el-menu-item index="3" @click="addedServicesButton"
                >增值服务</el-menu-item
              >
              <el-menu-item index="4" @click="boutiqueTaobaoButton"
                >精品淘题</el-menu-item
              >
              <el-sub-menu
                index="5"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper"
              >
                <template #title>
                  <p @click="teacherHandButton">教师助手</p>
                </template>
                <el-menu-item index="5-1" @click="researchButton"
                  >课题研究</el-menu-item
                >
                <el-menu-item index="5-2" @click="projectAchievementsButton"
                  >课题成果</el-menu-item
                >
                <el-menu-item index="5-3" @click="teachingActivitiesButton"
                  >教研活动</el-menu-item
                >
              </el-sub-menu>
              <el-sub-menu
                index="6"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper"
              >
                <template #title>
                  <p @click="studentWorldButton">学生天地</p>
                </template>
                <el-menu-item index="6-1" @click="KnowledgeDrivenGoodsButton"
                  >知识干货</el-menu-item
                >
                <el-menu-item index="6-2" @click="onlineLearningButton"
                  >在线学习</el-menu-item
                >
                <el-menu-item index="6-3" @click="thematicActivitiesButton"
                  >专题活动</el-menu-item
                >
                <el-menu-item index="6-4" @click="worksDisplayButton"
                  >作品展示</el-menu-item
                >
              </el-sub-menu>
              <el-sub-menu
                index="7"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper"
              >
                <template #title>
                  <p @click="parentSchoolButton">家长学堂</p>
                </template>
                <el-menu-item index="7-1" @click="talkPoliciesButton"
                  >说政策</el-menu-item
                >
                <el-menu-item index="7-2" @click="checkTheProcessButton"
                  >看流程</el-menu-item
                >
                <el-menu-item index="7-3" @click="fractionBarButton"
                  >分数线</el-menu-item
                >
                <el-menu-item index="7-4" @click="findAUniversityButton"
                  >找大学</el-menu-item
                >
                <el-menu-item index="7-5" @click="parentChildGardenButton"
                  >亲子园地</el-menu-item
                >
              </el-sub-menu>
              <el-sub-menu
                index="8"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper my-el-sub-menu-popper-last"
              >
                <template #title>经销授权</template>
                <el-menu-item index="8-1" @click="authorizedOnlineShopButton"
                  >授权网店</el-menu-item
                >
                <el-menu-item index="8-2" @click="offlineAgentButton"
                  >线下代理</el-menu-item
                >
              </el-sub-menu>
              <el-menu-item index="9" @click="walkIntroTianLiButton"
                >走进天利</el-menu-item
              >
            </el-menu>
          </div> -->
                  <div class="menu-box">
          <el-menu
            :default-active="mydata.activeIndex"
            class="el-menu-demo"
            mode="vertical"
            :ellipsis="false"
          >
            <template v-for="item in mydata.menuList" :key="item.id">
              <!-- 具有子级 -->
              <el-sub-menu
                v-if="Array.isArray(item.children)"
                :index="String(item.id)"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper"
              >
                <template #title>
                  <p @click="menuItemClick(item)" :class="{parentTextActived:String(mydata.activeIndex) === String(item.id)}">{{ item.title }}</p>
                </template>
                <el-menu-item
                  v-for="item2 in item.children"
                  :key="item2.id"
                  :index="String(item2.id)"
                  @click="menuItemClick(item2)"
                  >{{ item2.title }}</el-menu-item
                >
              </el-sub-menu>
              <!-- 没有子级 -->
              <el-menu-item
                v-else
                :index="String(item.id)"
                @click="menuItemClick(item)"
                >{{ item.title }}</el-menu-item
              >
            </template>
          </el-menu>
        </div>
        </template>
      </el-drawer>

      <img
        src="@/assets/三条杠 (2).png"
        alt=""
        @click="mydata.drawer2 = true"
      />

      <div class="center-box">
        <img
          v-complete:src="mydata.configObj.top_logo?.value"
          alt=""
          width="150px"
        />
        <!-- <p @click="goHome">
          {{ mydata.configObj.site_name?.value }}
        </p> -->
      </div>
      <!-- <img src="@/assets/我的.png" alt="" /> -->


      <!-- 头像 -->
      <img
        v-if="mydata.userInfo.avatar"
        v-complete:src="mydata.userInfo.avatar"
        @click="router.push({ path: '/layout/list/personalInfor' })"
        alt=""
        width="28px"
        height="28px"
        style="border-radius: 100%"
      />
      <!-- 头像2 -->
      <el-row class="demo-avatar demo-basic" v-else @click="router.push({ path: '/login/nowLogin' })">
        <el-col :span="12">
          <div class="demo-basic--circle">
            <div class="block">
              <el-avatar :size="50" :src="circleUrl" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>


    <router-view class="layout-router-view"></router-view>

   

    <lastBar></lastBar>
  </div>
</template>

<script setup>
import {
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
  toRefs,
  provide,
  inject
} from "vue";
// import { SwitchButton } from "@element-plus/icons-vue";
// // import { Upload} from "@element-plus/icons-vue";
import { Bell } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
// import bottomBar from "@/components/bottomBar/index.vue";
import lastBar from "@/components/lastBar/index.vue";

// 引入接口
import { outLogin } from "@/api/login/nowLogin/index.js";

import { useRouter, useRoute } from "vue-router";

import { useStore } from "vuex";

import { getConfig } from "@/api/list/index.js";

const store = useStore();

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // zoom: 1,
  // login: "登录",
  // register: "注册",
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {},

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  configObj: {},

  active: "",
  activeIndex: "17", // 这里不能写空字符串，因为它绑定给了default-active（页面加载时默认激活菜单的 index）应该是index下标不能为空字符串吧

  drawer2: false,
  direction: "ltr",
});

// 目录数组的id值所对应的url跳转地址
import { menuListIdUrl, getUrlId } from "@/utils/slide.js";

// 目录点击事件
function menuItemClick(menuItem) {
  // 获取跳转地址
  let url = menuListIdUrl[menuItem.id];
  // 如果跳转地址存在
  if (url) {
    // 跳转
    router.push({ path: url });
    // 激活
    mydata.activeIndex = String(menuItem.id);
  }
}

//引入slideShow接口
import { slideShow } from "@/api/slideShow/index.js";

import { getMenu } from "@/api/list/index.js";
// 调用getMenu函数（发送请求）
getMenu().then((res) => {
  //发送请求
  slideShow().then((res2) => {
    // 设置本地存储轮播图数组
    localStorage.setItem("slideObj", JSON.stringify(res2.data));
    /* 【等到轮播接口调用完毕之后再给目录数组赋值，让其他页面显示，因为其他页面里面使用了轮播的本地存储】这是目录的内容 start */
    // 赋值
    mydata.menuList = res.data;
    // 过滤
    mydata.menuList = mydata.menuList.filter((item) => {
      return item.type === 1;
    });
    // 排序
    mydata.menuList.sort((prev, next) => {
      return prev.sort - next.sort;
    });
    // 本地存储目录
    localStorage.setItem("menuList", JSON.stringify(mydata.menuList));
    /* 【等到轮播接口调用完毕之后再给目录数组赋值，让其他页面显示，因为其他页面里面使用了轮播的本地存储】这是目录的内容 end */
  });
});

// 依赖注入
provide("updateMydataUserInfo2", fn);
// 依赖注入
provide("configObj", toRefs(mydata).configObj);

// 获取配置数据
function getConfigFn() {
  getConfig().then((res) => {
    mydata.configObj = res.data;
  });
}

getConfigFn();

function fn() {
  mydata.userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {}
}

const { circleUrl, sizeList } = toRefs(mydata);

//loge点击事件
function goHome() {
  router.push({
    path: "/layout/list/home",
  });
}


// 点击退出登录按钮
function exitClick() {
  outLogin({ token: mydata.userInfo.jwt }).then((res) => {
    // 提示弹窗
    ElMessage({
      message: "退出成功",
      type: "success",
    });
    // 清除本地存储的用户信息
    localStorage.removeItem("userInfo");
    // 获取用户信息
    mydata.userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {} //用户信息
      // 跳转页面到首页
      router.push({
        // path: "/layout/list/personalCenter",
        path: "/layout/list/home",
      });
  });
}

//登录点击事件
function nowLoginButton() {
  router.push({
    path: "/login/nowLogin",
  });
}

//注册点击事件
function loginRegisterButton() {
  router.push({
    path: "/loginRegister",
  });
}


//首页
function homeButton() {
  router.push({
    path: "/layout/list/home",
  });
}

//图书介绍
function highSchoolButton() {
  router.push({
    path: "/layout/list/highSchoolBooks",
  });
}
function middleSchoolButton() {
  router.push({
    path: "/layout/list/middleSchoolBooks",
  });
}

function primarySchoolButton() {
  router.push({
    path: "/layout/list/primarySchoolBooks",
  });
}

//增值服务
function addedServicesButton() {
  router.push({
    path: "/layout/list/addedServices",
  });
}

//精品淘题
function boutiqueTaobaoButton() {
  router.push({
    path: "/layout/list/boutiqueTaobaoQuestions",
  });
}

//教师助手
function researchButton() {
  router.push({
    path: "/layout/list/research",
  });
}

function projectAchievementsButton() {
  router.push({
    path: "/layout/list/projectAchievements",
  });
}

function teachingActivitiesButton() {
  router.push({
    path: "/layout/list/teachingActivities",
  });
}
function teacherHandButton() {
  router.push({
    path: "/layout/list/teacherHand",
  });
}

//学生天地
function studentWorldButton() {
  router.push({
    path: "/layout/list/studentWorld",
  });
}
function KnowledgeDrivenGoodsButton() {
  router.push({
    path: "/layout/list/KnowledgeDrivenGoods",
  });
}
function onlineLearningButton() {
  router.push({
    path: "/layout/list/onlineLearning",
  });
}
function thematicActivitiesButton() {
  router.push({
    path: "/layout/list/thematicActivities",
  });
}
function worksDisplayButton() {
  router.push({
    path: "/layout/list/worksDisplay",
  });
}

//家长学堂
function parentSchoolButton() {
  router.push({
    path: "/layout/list/parentSchool",
  });
}

function talkPoliciesButton() {
  router.push({
    path: "/layout/list/talkPolicies",
  });
}

function checkTheProcessButton() {
  router.push({
    path: "/layout/list/checkTheProcess",
  });
}

function fractionBarButton() {
  router.push({
    path: "/layout/list/fractionBar",
  });
}

function findAUniversityButton() {
  router.push({
    path: "/layout/list/findAUniversity",
  });
}

function parentChildGardenButton() {
  router.push({
    path: "/layout/list/parentChildGarden",
  });
}

//经销授权
function authorizedOnlineShopButton() {
  router.push({
    path: "/layout/list/authorizedOnlineShop",
  });
}

function offlineAgentButton() {
  router.push({
    path: "/layout/list/offlineAgent",
  });
}

//走进天利
function walkIntroTianLiButton() {
  router.push({
    path: "/layout/list/walkIntroTianLi",
  });
}














//点击个人中心跳转到个人中心首页
// function goUserInfoPage() {
//   router.push({
//     path: "/layout/list/personalCenter/personalInfor",
//   });
// }

//点击铃铛图标跳转至个人中心的站内消息
// function messageFn() {
//   router.push({
//     path: "/layout/list/personalCenter/myNotifications",
//   });
// }


</script>

<style>
.my-menu-box {
  width: 100%;
  border: none !important;
}
.el-drawer.ltr.open {
  width: 80% !important;
  /* 因为有些页面的样式还没有调整，所以有些页面宽度比较宽，抽屉的宽度使用百分比的话，也会因此而有的页面里面抽屉比较宽，有的页面里面抽屉比较窄，所以暂时写死成300px吧 */
  width: 300px !important;
}
</style>

<style scoped lang="scss">
// .box{
//   margin-top:300px;
// }
.layout {
  // border: 1px solid tomato;
  // height: 2508px;
  width:375px;
  height: 100%;
  // overflow: hidden;
  // padding-top: 40px;
  overflow: visible;
}
.header {
  width: 100%;
  // min-width: 375px;
  height: 50px;
  // position: fixed;
  position: sticky;
  top: 0;
  border-bottom: 1px solid #cccccc;
  background-color: #ffffff;
  z-index: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 1000;
  box-shadow: 0 0px 4px 0px #0015291f;
  background: #ffffff;
  padding: 0px 13px;
  > img:first-of-type {
    width: 24px;
    height: 24px;
  }
  > img:last-of-type {
    width: 24px;
    height: 24px;
  }
 .center-box {
    // border: 1px solid red !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // > img {
    //   width:200px;
    //   // height:30px;
    //   // margin-right: 6px;
    // }
    // > p {
    //   font-size: 20px;
    //   font-weight: 700;
    //   color: #000000;
    //   cursor: pointer
    // }
  }

  ////////头像样式
  :deep(.el-row.demo-avatar.demo-basic) {
    width: 28px;
    height: 28px;
    // border: 1px solid red;
    // 头像框
    .demo-basic--circle {
      width: 28px;
      height: 28px;
      // border:1px solid red;
    }
    //头像框
    .block {
      width: 28px;
      height: 28px;
      // border:1px solid red;
    }
    //圆头像
    .el-avatar.el-avatar--circle {
      width: 28px;
      height: 28px;
      // border: 1px solid blue;
    }
  }

  // :deep(.el-icon) {
  //   position: absolute;
  //   right: 100px;
  //   font-size: 24px;
  //   font-weight: 900;
  // }
  // .el-icon:hover {
  //   color: #2150b7;
  //   font-size: 26px;
  // }
}

//-------------回到顶部按钮--------------------
// :deep(.el-backtop) {
//   // border:1px solid red;
//   width: 60px;
//   height: 60px;
//   .el-icon {
//     font-size: 35px;
//     font-weight: 900;
//   }
// }

// .bottomBar{
//   position:absolute;
//   bottom:0px;
//   // z-index: 1000;
// }
// :deep(.el-overlay){
//   z-index: 100000000000000000001 !important;
// }


// 父级元素激活样式
:deep(.el-sub-menu:has(.parentTextActived)){
  // border-bottom: 2px solid #409eff !important;
  .parentTextActived{
    color: #409eff !important;
  }
}

// 子级元素激活样式
:deep(.el-sub-menu .el-menu.el-menu--popup .el-menu-item.is-active){
  color: #409eff !important;
}

// 隐藏蒙版层
:deep(.el-menu-item:focus,.el-sub-menu:focus){
  background: transparent !important;
}
// 初始设置边框，防止激活的时候因为设置了边框而导致文字跳动
:deep(.el-sub-menu){
  border-bottom: 2px solid transparent !important;
}

// 目录
:deep(.el-menu){
  border-right:none !important;
}

</style>
